import './styles/Home.module.css'
import { Col, Row } from 'antd'

export default function CollectionLayout(props) {
  const itemData = props.itemData ?? []
  const getDetailUrl = (item) => {
    const name = item.name
      .replace(/[^a-zA-Z ]/g, '')
      .toLowerCase()
      .replaceAll(' ', '_')
    return 'https://revart.co/artworks/info/' + name + '_' + item.id
  }
  const newTab = (item) => {
    window.open(getDetailUrl(item), '_blank')
  }
  const getName = (item) => {
    if (item.year && item.year !== -1) {
      return item.name + ', ' + item.year
    }
    return item.name
  }
  return (
    <div
      style={{
        width: '100%',
        paddingTop: 6,
        paddingBottom: 6,
        maxWidth: 1000,
        marginRight: 'auto',
        marginLeft: 'auto'
      }}
    >
      <div
        style={{
          paddingLeft: '6%',
          paddingRight: '6%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold' }}>{props.title}</h1>
        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32
          }}
          style={{ width: '100%' }}
        >
          {itemData.map((item) => (
            <Col span={props.matchDownMd ? 6 : 12}>
              <div
                key={item.id}
                onClick={() => {
                  newTab(item)
                }}
                style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
              >
                <img
                  style={{ cursor: 'pointer', width: '100%' }}
                  src={`${item.static_url}`}
                  srcSet={`${item.static_url}`}
                  alt={item.name}
                  loading='lazy'
                />
                <h5 style={{ marginTop: 6, marginLeft: 'auto', marginRight: 'auto' }}>{getName(item)}</h5>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  )
}
